import React, { Component } from 'react'
import './Slide.css'

class Slide extends Component {
  render () {
    return (
      <section className='Slide animated' ref={(slide) => { this.domElement = slide }}>
        {this.props.children}
      </section>
    )
  }
}

export default Slide



// WEBPACK FOOTER //
// ./src/Containers/Slide/Slide.js